import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=b1083cec&scoped=true&lang=pug&"
import script from "./Setting.vue?vue&type=script&lang=coffee&"
export * from "./Setting.vue?vue&type=script&lang=coffee&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=b1083cec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1083cec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
